import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";

function ViewFAQs(props) {
    const {
        setViewModalFlag
    } = props
    const [question, setQuestion] = useState<string>("")
    const [answers, setAnswers] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const [loadingData, setLoadingData] = useState<boolean>(false)

    const borderRadiusStyle = { borderRadius: 2 };

    useEffect(() => {
        setLoadingData(true)
        const obj = JSON.parse(sessionStorage.getItem("FAQsObj") || "");
        setQuestion(obj?.question?.trim() || "")
        setAnswers(obj?.answer?.trim() || "")
        setStatus(obj?.status)
        setLoadingData(false)
    }, [])


    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                {!loadingData ?
                    <Row>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Question</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Question'
                                    value={question}
                                    disabled
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Answer</label>
                                <textarea
                                    rows={3}
                                    className="form-control"
                                    placeholder='Enter Answer'
                                    value={answers}
                                    disabled
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Status</label>
                                <ToggleButton
                                    inactiveLabel=""
                                    activeLabel=""
                                    value={status}
                                    thumbStyle={borderRadiusStyle}
                                    trackStyle={borderRadiusStyle}
                                // onToggle={() => {
                                //     setStatus(!status)
                                // }}
                                />
                            </div>
                        </Col>
                    </Row> :
                    <div className="d-flex justify-content-center my-5">
                        <div
                            className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                            role="status"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setViewModalFlag(false)}
                    >
                        Cancel
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default ViewFAQs